<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="saving || disabled"
    i18n
  >
    Save
  </button>
  <mat-progress-spinner
    *ngIf="saving"
    diameter="24"
    mode="indeterminate"
  ></mat-progress-spinner>
  <button mat-button color="warn" (click)="reset()" [disabled]="saving" i18n>
    Reset
  </button>
</div>
